export default "<div *ngIf=\"isLoading | async\" id=\"loader\">\n    <div id=\"spinner\"></div>\n</div>\n";